(function() {
  const swiperTestimonials = document.querySelector('.with-swipe-slides');
  if(swiperTestimonials){
    const sliders_section = document.querySelectorAll(".with-swipe-slides");
    
    
    sliders_section.forEach(function(element) {
     const main_elem_id = element.id
      
      let mobile_size = 1.2;
      const slider_element = element.querySelector('.swiper_testimonials');
      let navigation_left = '';
      let navigation_right = '';
      const navigation_container = element.querySelector(`#${slider_element.id}`);
      if(navigation_container){
          navigation_left = `#${main_elem_id} .swiper-button-prev`;
          navigation_right = `#${main_elem_id} .swiper-button-next`;
      }
      const idValue = `#${slider_element.id}`;
      const desktop_slide = parseFloat(slider_element.dataset.koh_slides);
      const super_desktop = Math.round(desktop_slide);
      console.log(super_desktop);
      if (slider_element && slider_element.hasAttribute('data-koh_mobile_slides')) {
        mobile_size = parseFloat(slider_element.dataset.koh_mobile_slides);
      }
      console.log(mobile_size);
      var swiper = new Swiper(idValue, {
          slidesPerView: 3,
          centeredSlides: true,
          pagination: {
            el: `${idValue} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: mobile_size,
              centeredSlides: true,
              loop: true,
              spaceBetween: 10,
              pagination: {
                enabled: true
              }
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 2,
              centeredSlides: false,
              spaceBetween: 10,
              pagination: {
                enabled: true
              }
            },
            1279: {
              slidesPerView: desktop_slide,
              centeredSlides: false,
              spaceBetween: 18,
              pagination: {
                enabled: true
              },
              navigation: {
                nextEl: navigation_right,
                prevEl: navigation_left,
              },
            },
            1920: {
              slidesPerView: super_desktop,
              centeredSlides: false,
              spaceBetween: 18,
              pagination: {
                enabled: true
              },
              navigation: {
                nextEl: navigation_right,
                prevEl: navigation_left,
              },
            }
          }
      });
    })
  }
})();

(function() {
  class PannelController {
    constructor(container) {
      this.container = container;

      this.button_trigger = this.container.querySelector('[data-custom-pannel-control]');
      this.panel_to_trigger = this.container.nextElementSibling;

      this.button_trigger.addEventListener("click", this.togglePannelVisibility.bind(this));
    }

    togglePannelVisibility() {
      // Toggle the hidden attribute of the panel
      if (this.panel_to_trigger.hasAttribute('hidden')) {
        this.button_trigger.setAttribute('active', '');
        this.panel_to_trigger.removeAttribute('hidden');
      } else {
        this.button_trigger.removeAttribute('active');
        this.panel_to_trigger.setAttribute('hidden', '');
      }
    }
  }

  // Select all navigation item containers
  const controlElements = document.querySelectorAll('.navigation-item');
  controlElements.forEach((element) => {
    // Initialize a PannelController for each navigation item
    new PannelController(element);
  });
})();